import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const ProductCard = ({ product, index = 0 }) => {
  const { tp, tcat, tprice } = useLang();
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: (index % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`product-card-${product.slug}`}
    >
      <Link
        to={`/products/${product.slug}`}
        className="group relative block h-full overflow-hidden rounded-2xl border border-gold/15 bg-navy-800 hover:border-gold/45 transition-colors duration-500"
      >
        <div className="relative overflow-hidden aspect-[4/5]">
          {product.fit === "cover" ? (
            <>
              <img
                src={product.image}
                alt={product.name}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/10 to-transparent" />
            </>
          ) : (
            <>
              <div className="absolute inset-0 radial-glow opacity-60" />
              <img
                src={product.image}
                alt={product.name}
                loading="lazy"
                className="relative h-full w-full object-contain p-8 drop-shadow-2xl transition-transform duration-700 ease-out group-hover:scale-[1.06]"
              />
            </>
          )}
          <span className="absolute top-4 left-4 z-10 rounded-full border border-gold/30 bg-navy-950/60 backdrop-blur px-3 py-1 text-[10px] uppercase tracking-[0.2em] text-gold">
            {tcat(product.category)}
          </span>
        </div>

        <div className="relative p-6 md:p-7 border-t border-gold/10">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="font-serif text-white leading-tight text-2xl">{tp(product, "name")}</h3>
              <p className="mt-1 text-sm text-white/50 font-light">{tp(product, "tagline")}</p>
            </div>
            <span className="grid place-items-center h-10 w-10 shrink-0 rounded-full border border-gold/30 text-gold transition-[background,color,transform] duration-500 group-hover:bg-gold group-hover:text-navy-900 group-hover:rotate-45">
              <ArrowUpRight size={18} />
            </span>
          </div>

          <div className="mt-4 flex flex-wrap items-center gap-2">
            <span className="text-xs text-gold/90">{product.weight}</span>
            <span className="h-1 w-1 rounded-full bg-white/25" />
            <span className="text-xs text-white/45">{tprice(product.priceLabel)}</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
